module.exports = __webpack_public_path__ + "img/pag.f5410ad7.svg";